import {Box, Button, Card, Stack, Typography} from "@mui/joy";
import React from "react";
import {CreditCard, Dot} from "lucide-react";
import ActiveSubscriptionComponent from "../../components/Subscription/ActiveSubscriptionComponent";
import {useTranslation} from "react-i18next";

const SubscriptionSettingsSection = () => {
    const {t} = useTranslation()
    return <Stack gap={2}>

        <ActiveSubscriptionComponent/>

        {/*<Card data-no-glow data-no-animation sx={{padding: 3}}>*/}
        {/*    <Typography level={"title-md"}>*/}
        {/*        {t("paymentMethodTitle")}*/}
        {/*    </Typography>*/}

        {/*    <Stack gap={2}>*/}

        {/*        <Card data-no-glow data-no-animation sx={{padding: 2}}>*/}
        {/*            <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>*/}

        {/*                <Stack gap={2} direction={"row"} alignItems={"center"}>*/}
        {/*                    <Box paddingX={1.5} paddingY={0.5} borderRadius={7} sx={{backgroundColor: "blue"}}>*/}
        {/*                        <CreditCard color={"white"} style={{fontSize: 30}}/>*/}
        {/*                    </Box>*/}

        {/*                    <Stack>*/}
        {/*                        <Typography level={"title-lg"}>*/}
        {/*                            ... 4242*/}
        {/*                        </Typography>*/}

        {/*                        <Typography>*/}
        {/*                            {t("creditCardPaymentMethodExpiryLabel", {date: "11/27"})}*/}
        {/*                        </Typography>*/}
        {/*                    </Stack>*/}
        {/*                </Stack>*/}

        {/*                <Typography color={"success"}>*/}
        {/*                    {t("defaultPaymentMethodLabel")}*/}
        {/*                </Typography>*/}

        {/*            </Stack>*/}
        {/*        </Card>*/}

        {/*        <Button color={"neutral"} variant={"outlined"} sx={{width: "max-content"}}>*/}
        {/*            {t("addPaymentMethodActionLabel")}*/}
        {/*        </Button>*/}

        {/*    </Stack>*/}
        {/*</Card>*/}
    </Stack>
}

export default SubscriptionSettingsSection